var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.stage.deleted
    ? _c("div", { staticClass: "email-template-wrapper" }, [
        _c("div", { staticClass: "email-action-select" }, [
          _c(
            "div",
            { staticClass: "d-flex flex-column justify-content-center" },
            [
              _vm.isFirstEmail
                ? _c("div", [
                    _c("div", { staticClass: "text-center" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-sm clickable d-inline mx-2",
                          class: { "btn-primary": _vm.isSendInstantly },
                          on: {
                            click: function ($event) {
                              return _vm.handleChangeDaysToWait({ value: 0 })
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("global.words.send")))]
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "drip-campaigns.stages.editEmails.firstEmail"
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "my-2 text-center text-uppercase" },
                      [_c("b", [_vm._v(_vm._s(_vm.$t("global.words.or")))])]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "row no-gutters align-items-center justify-content-center",
                },
                [
                  _c("div", { staticClass: "col-auto" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.words.wait")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c(
                        "b-dropdown",
                        {
                          staticClass: "m-md-2",
                          attrs: {
                            id: "dropdown-1",
                            "no-caret": "",
                            "toggle-class": "text-decoration-none p-0",
                            variant: "link",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button-content",
                                fn: function () {
                                  return [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-sm dropdown-toggle clickable",
                                        class: {
                                          "btn-primary": !_vm.isSendInstantly,
                                          "text-dark": _vm.isSendInstantly,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.daysToWaitDropdownText) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3962408084
                          ),
                        },
                        [
                          _vm._v(" "),
                          _vm._l(_vm.waitDays, function (duration) {
                            return _c(
                              "b-dropdown-item",
                              {
                                key: duration.value,
                                on: {
                                  click: function ($event) {
                                    return _vm.handleChangeDaysToWait({
                                      value: duration.value,
                                      label: duration.label,
                                    })
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(duration.label) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isCustomDaysToWait
                    ? _c(
                        "div",
                        { staticClass: "col-3 col-lg-1" },
                        [
                          _c(
                            "material-input",
                            {
                              staticClass:
                                "drip-campaign-email-editor-custom-days d-inline-block",
                              attrs: {
                                value: _vm.stage.daysToWait,
                                "custom-expression":
                                  "currentCampaign.stages.$each[" +
                                  _vm.index +
                                  "].daysToWait",
                                label: _vm.$tc("global.words.day", 2),
                              },
                            },
                            [
                              _c("numeric-input", {
                                attrs: {
                                  value: _vm.stage.daysToWait,
                                  name: "days-to-wait",
                                  min: 1,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleChangeDaysToWait({
                                      value: $event.target.value,
                                      label: "custom-option",
                                    })
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-auto" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "drip-campaigns.stages.editEmails.beforeSending"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c("time-picker", {
                        attrs: {
                          id: "drip-campaign-time-" + _vm.index,
                          value: _vm.stage.timeToSendAt,
                          "default-value": _vm.defaultTimeToSendAt,
                          "format-type": "seconds",
                        },
                        on: { input: _vm.handleChangeTime },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          attrs: {
                            for: "drip-campaign-time-" + _vm.index,
                            hidden: "",
                          },
                        },
                        [_vm._v("Drip Campaign Time")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters email-template-select" }, [
          _c(
            "div",
            {
              staticClass:
                "col-auto email-counter d-flex flex-row justify-content-center align-items-center",
            },
            [
              _c("h4", { staticClass: "bold text-capitalize" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$tc("global.words.email", 1) + " " + (_vm.index + 1)
                    ) +
                    "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _vm.hasStatistics
                ? _c("drip-campaign-email-statistics", {
                    attrs: { statistics: _vm.stage.statistics },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row select-fields-wrapper align-items-center" },
                [
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c("drip-campaign-template-select", {
                        attrs: {
                          stage: _vm.stage,
                          index: _vm.index,
                          "campaign-id": _vm.campaignId,
                        },
                        on: { "template-delete": _vm.handleTemplateDelete },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("campaign-subject-section", {
                        attrs: {
                          "subject-data": _vm.subjectData,
                          label: false,
                          "custom-expressions": _vm.subjectCustomExpressions,
                        },
                        on: { change: _vm.handleSubjectChange },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mb-3" },
                        [
                          _c("radio-section", {
                            attrs: {
                              name: "email-" + _vm.index,
                              options: _vm.coApplicantsSendOptions,
                              checked: _vm.selectedCoApplicantsSendOption,
                            },
                            on: { change: _vm.handleSendCoApplicantsChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "position-absolute",
                      staticStyle: { right: "0.5rem", top: "0.5rem" },
                    },
                    [
                      !_vm.isFirstEmail
                        ? _c(
                            "inline-prompt",
                            {
                              staticClass: "clickable",
                              staticStyle: { "font-size": "0.8rem" },
                              attrs: {
                                "action-type": "delete",
                                placement: "left",
                                "confirmation-text": _vm.$t(
                                  "global.actions.confirmDelete"
                                ),
                              },
                              on: { accept: _vm.handleDelete },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-trash text-danger",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm._m(1),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vertical-line" }, [
      _c("div", { staticClass: "left-half" }),
      _vm._v(" "),
      _c("div", { staticClass: "right-half" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vertical-line" }, [
      _c("div", { staticClass: "left-half" }),
      _vm._v(" "),
      _c("div", { staticClass: "right-half" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }